import React from 'react'
import {CCol, CContainer, CRow} from "@coreui/react-pro";
import StatCard from "../../../components/employer/StatCard";
import {FaUsers, FaSchool, } from "react-icons/fa";
import { AiFillDiff } from "react-icons/ai";
import { BsFillBriefcaseFill } from "react-icons/bs";
import {useGetUsersQuery} from "../../../hooks/employer/employerApiHooks";
import ShowLoading from "../../../components/ShowLoading";
import DataNotFound from "../../../components/DataNotFound";
import {
    useGetAllQuestionnairesQuery, useGetAppStats,
    useGetJobsQuery,
    useGetTrainingProgramQuery
} from "../../../hooks/user/userApiHooks";

const AdminDashboard = () => {
    const card_colors = ["card-border-green-500", "card-border-red", "card-border-yellow", "card-border-green-900"]
    const {
        isLoading,
        data: userData
    } = useGetUsersQuery()

    const jobs = useGetJobsQuery(1, 1, '', '', '', true);
    const training = useGetTrainingProgramQuery(1, 1, '', '', true)
    const {data: allSkills, isSuccess: isSkill} = useGetAllQuestionnairesQuery()

    const {
        isLoading: isStatLoading,
        isSuccess: isStatSuccess,
        data: statData
    } = useGetAppStats()

    console.log()

    const stats = [
        {
            total: statData?.data?.data?.users || "0",
            title: "Total Users",
            icon: FaUsers,
            to: '/admin/applicants'
        },
        {
            total: statData?.data?.data?.training || "0",
            title: "Total Trainings",
            icon: FaSchool,
            //to: '/employer/my-programs'
        },
        {
            total: statData?.data?.data?.jobs || "0",
            title: "Total Jobs",
            icon: BsFillBriefcaseFill,
            to: '/admin/reports'
        },
        {
            total: allSkills?.data?.data?.length || "0",
            title: "Total Assessment",
            icon: AiFillDiff,
            to: '/admin/assessments'
        }
    ]

    if (isLoading) {
        return <ShowLoading/>
    }

    return <>
        <div>
            <CRow >
                {
                    stats?.map((stat, index) =>
                        <CCol className="w-100 mt-2" key={index}>
                            <StatCard pinned={stat} index={index} width={12} card_colors={card_colors} textColor={"text-black-50"}/>
                        </CCol>
                    )
                }
            </CRow>
            <div>
                <CContainer className="container-border mt-4 p-4">
                    <DataNotFound/>
                </CContainer>

            </div>
        </div>
    </>
}

export default AdminDashboard
